/* eslint-disable no-unused-expressions */
import {
  AppBar,

  Avatar, Box,
  Checkbox,


  Divider,

  FormControlLabel, Grid,

  Icon, List,
  ListItem,
  ListItemAvatar, ListItemIcon,
  ListItemText,
  ListSubheader, Toolbar,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import { Autocomplete } from '@material-ui/lab';
import algoliasearch from 'algoliasearch/lite';
import { loadCSS } from 'fg-loadcss';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { algoliaIndex } from 'src/utils/algoliadata';
import { history } from 'src/utils/utils';
import requestlyLogo from "../../image/requestly_logo_white.png";
import './css/product.scss';


const searchClient = algoliasearch('JE3UA8IZ0R', 'dfb17da784818795fc420e50bfb6cfdb');
const searchIndex = searchClient.initIndex(algoliaIndex);
const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    flexGrow: 1,
    fontFamily: '"Spartan", sans-serif!important'
    // background: `url(${wave})`,
    // backgroundSize: 'cover',
    // backgroundColor: '#64829a59',
    // backgroundBlendMode: 'screen'
  },
  videoStyle: {
    objectFit: 'cover',
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: -1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  headerStyle: {
    background: '#F2564C'
  },
  title: {
    cursor: 'pointer',
    color: '#fff',
    fontSize: '3rem',
    fontWeight: 600,
    padding: '0.2em 0',
    fontFamily: '"Spartan", sans-serif!important'
  },
  productName: {
    color: '#fff',
    padding: '0.2em 0',
    fontSize: '2rem',
    fontFamily: '"Spartan", sans-serif!important',
    fontWeight: 700,
    paddingLeft: '1rem',
    display: 'inline',
    verticalAlign: 'middle',
    position: 'relative'
  },
  companyName: {
    fontSize: '10px',
    display: 'inherit',
    color: 'white',
    textAlign: 'right',
    backgroundColor: '#7c8591',
    fontFamily: '"Spartan", sans-serif!important',
    letterSpacing: '.2rem',
    padding: '0.5em 1.3em',
    borderRadius: '0 2px 2px 0',
    position: 'absolute',
    top: '2.5rem',
    right: 0
  },
  getStartedButtonStyle: {
    background: '#F2564C',
    color: '#fff'
  },
  rightNav: {
    width: '100%',
    paddingLeft: '78px',
  },
  rightNavText: {
    color: '#000',
    fontFamily: '"Spartan", sans-serif!important'
  },
  navList: {
    listStyle: 'none',
    padding: '1em 0,',
    margin: 0,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  navListItem: {
    padding: '0.5em 0',
    marginLeft: '3em',
    color: 'black',
    position: 'relative',
    cursor: 'pointer',
    '&::after': {
      content: '""',
      display: 'block',
      height: '3px',
      width: 0,
      backgroundColor: '#F2564C',
      position: 'absolute',
      bottom: 0,
      transition: '0.2s'
    }
  },
  searchInputStyle: {
    width: '45%',
    color: '#000',
    height: '2.5rem',
    outlineWidth: 0,
    fontWeight: 600,
    borderRadius: '2rem',
    border: '2px solid #fff',
    padding: '0 6.5% 0px 3.5%',
    textOverflow: 'ellipsis',
    fontSize: '.8rem',
    background: 'white'
  },

  iconSize: {
    color: "#707070",
  },
  searchWrapper: {
    width: '50vW',
    position: 'absolute',
    top: '40%'
  },
  searchBarWrap: {
    textAlign: 'left'
  },
  paper: {
    textAlign: 'center',
    padding: '2px 5px 2px 5px',
    background: '#000',
    color: '#fff'
  },
  footerWrapper: {
    position: 'absolute',
    bottom: '2rem',
    width: '70vW',
    textAlign: 'center',
    justifyContent: 'center'
  },
  iconStyle: {
    fontSize: '2.5rem',
    verticalAlign: 'middle'
  },
  footerText: {
    background: 'transparent',
    border: 0,
    boxShadow: 'unset',
    fontSize: '3rem',
    color: '#fff',
    fontWeight: 200
  },
  paperTextOur: {
    background: '#f2564c'
  },
  paperText: {
    verticalAlign: 'middle',
    display: 'inline'
  },
  autoCompleteTextStyle: {
    color: '#000',
    fontSize: '.7rem'
  },
  sliderBg: {
    background: 'url(/static/media/s1.3a39b803.png)',
    backgroundSize: 'cover',
    padding: '0px 0 0 10px',
    display: 'block',
    backgroundRepeat: 'no-repeat',
    height: '30rem',
    minHeight: '30rem',
    backgroundPosition: 'center',
    overflow: 'hidden'
  },
  logoSecCover: {
    padding: 0
  },
  companyInfoSec: {
    display: 'block',
    float: 'left',
    position: 'absolute',
    bottom: 0,
    marginBottom: '.2rem'
  },
  companyInfoLink: {
    padding: '1.4rem',
    background: '#f2564c',
    color: '#fff',
    borderRadius: '.5rem .5rem 0rem .0rem',
    '&:hover': {
      color: '#fff'
    }
  },
  overviewStyle: {
    paddingTop: '0rem'
  },
  overviewTextStyle: {
    fontSize: '1rem'
  },
  companyIntroBlock: {
    position: 'absolute',
    top: '-34px',
    left: '19px',
    display: 'block',
    background: 'transparent',
    padding: '0px 17px'
  },
  boxBorder: {
    position: 'relative',
    bottom: '0px',
    backgroundColor: 'red'
  },
  boxborder: {
    border: '1px solid gainsboro',
    margin: '8px',
    padding: '0px 10px 5px 15px',
    borderRadius: '10px'
  },
  introText: {
    width: '6.5em',
    fontSize: '1.6rem!important',
    marginTop: '-10px',
    marginLeft: '24px',
    background: '#f4f6f8'
  },
  boxborder4: {
    border: '1px solid gainsboro',
    margin: '8px',
    borderRadius: '10px'
  },
  detailsText: {
    width: '5rem',
    background: '#f4f6f8',
    marginTop: '-10px',
    marginLeft: '25px',
    fontSize: '1.6rem!important'
  },
  detailsTextDetail: {
    padding: '0px 10px 10px 10px',
    margin: 0,
    fontSize: '1rem'
  },
  noPadding: {
    padding: 0
  },
  autoCompletePopperProduct: {
    width: '30vW!important',
    maxWidth: '30vW!important',
    top: '3px!important',
    left: '-15%!important'
  },
  autoCompleteTextStyle: {
    color: '#000',
    fontSize: '.7rem'
  },
  gridStyle: {
    display: 'inline-block'
  },
  listStyle: {
    maxHeight: '400px',
    overflow: 'scroll',
    background: '#eeeeee',
    borderRadius: '5px',
    paddingBottom: 0
  },
  listHeader: {
    fontSize: '18px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.22',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000000',
    padding: '1rem',
    borderRadius: '5px'
  },
  containerPadding: {
    padding: '1rem'
  },
  expandMore: {
    textAlign: 'center',
    justifyContent: 'center'
  },
  employeeFilterList: {
    marginTop: '1rem'
  },
  listItemCategory: {
    paddingTop: 0,
    paddingBottom: 0,
    display: '-webkit-box'
  },
  categoriesName: {
    padding: '0!important',
    margin: 0
  },
  gridStyleList: {
    padding: '0 1rem'
  },
  categoriesText: {
    fontSize: '.7rem!important'
  },
  checkBoxStyleList: {
    minWidth: '30px'
  },
  logoFit: {
    objectFit: 'contain!important'
  },
  productNameStyle: {
    fontWeight: 'bolder'
  },
  productOverview: {
    fontSize: '.8rem',
    color: '#000000!important',
    float: 'left!important',
    textAlign: 'justify',
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkitLineClamp': 4,
    '-webkitBoxOrient': 'vertical'
  },
  listItemDetailStyle: {
    paddingTop: '1em',
    paddingBottom: '1em'
  },
  productListStyle: {
    paddingTop: 0
  },
  productImage: {
    borderRadius: '0!important'
  },
  closeIconStyle: {
    cursor: 'pointer',
    fontSize: '1.2rem'
  },
  loginButton: {
    position: "absolute",
    left: "88%",
    top: "24%",
    cursor: "pointer"
  },
  '@global': {
    '.MuiAvatar-root': {
      width: "90px",
      height: "90px",
      marginRight: "10px"
    },
    '.MuiIcon-root': {
      fontSize: "1rem !important"
    }
  },

}));

const ProductPage = (props) => {
  let isMounted = true;
  const [isFirstLoad, setIsFirstLoad] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [isSubOpen, setIsSubOpen] = React.useState(false);
  const [isKeywordOpen, setIsKeywordOpen] = React.useState(false);
  const [isCompanyOpen, setIsCompanyOpen] = React.useState(false);

  const [options, setOptions] = useState([]);
  const [product, setProduct] = useState([]);
  const [querySearch, setQuerySearch] = useState('');
  const [categories, setCategories] = useState({});
  const [subCategories, setSubcategories] = useState({});
  const [allKeywords, setAllKeywords] = useState({});
  const [targetPersona, setTargetPersona] = useState({});
  const [company, setCompany] = useState({});
  const [numericFilters, setNumericFilters] = useState([]);
  const [page, setPage] = useState(0);
  const [nbPages, setNbPages] = useState(0);
  const [nbHits, setNbHits] = useState(0);
  const [showProducts, setShowProducts] = useState({ category: false, subCategory: false, company: false, keywords: false, val: '' })

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [selectedAllKeywords, setSelectedAllKeywords] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [selectedTargetPersona, setSelectedTargetPersona] = useState([]);


  const fetchData = async () => {
    const query = queryString.parse(props.location.search);
    setQuerySearch(query.search);
    // eslint-disable-next-line no-nested-ternary
    setPage(query.page);
    if (query.category && query.category !== '') {
      setSelectedCategories(query.category.split(','));
    }
    if (query.subCategory && query.subCategory !== '') {
      setSelectedSubCategories(query.subCategory.split(','));
    }
    if (query.allKeywords && query.allKeywords !== '') {
      setSelectedAllKeywords(query.allKeywords.split(','));
    }
    if (query.targetPersona && query.targetPersona !== '') {
      setSelectedTargetPersona(query.targetPersona.split(','));
    }
    if (query.company && query.company !== '') {
      setSelectedCompany(query.company.split(','));
    }
    // if (query.company && query.company !== '') {
    //   setSelectedCompany(query.company.split(','));
    // }
    // eslint-disable-next-line react/prop-types
    // You can await here
    await searchIndex
      .search(query.search, {
        hitsPerPage: 20,
        facets: ['category', 'subCategory', 'allKeywords', 'company', 'targetPersona'],
        facetFilters: [
          query.category ? query.category.split(',') : [],
          query.subCategory ? query.subCategory.split(',') : [],
          query.allKeywords ? query.allKeywords.split(',') : [],
          query.targetPersona ? query.targetPersona.split(',') : [],
          query.company ? query.company.split(',') : []
        ],
        page,
        numericFilters
      })
      .then(async ({
        hits, facets, nbPages, page, nbHits
      }) => {
        setIsFirstLoad(false);
        let productDetail = hits;
        console.log(facets, "facets")
        const { category, subCategory, allKeywords, company, targetPersona } = facets;
        category ? setCategories(category) : setCategories([]);
        subCategory ? setSubcategories(subCategory) : setSubcategories([]);
        allKeywords ? setAllKeywords(allKeywords) : setAllKeywords([]);
        company ? setCompany(company) : setCompany([]);
        targetPersona ? setTargetPersona(targetPersona) : setCompany([]);
        let arrayWithoutLogo = [];
        let arrayWithLogo = [];

        productDetail.map((value) => {
          if (value.squareLogo === "") {
            arrayWithoutLogo.push(value)
          } else {
            arrayWithLogo.push(value)
          }
        })
        productDetail = [...arrayWithLogo, ...arrayWithoutLogo]

        setProduct(productDetail);
        if (nbHits > 20 && (querySearch !== "" || query.category !== "" || query.allKeywords.length !== "" || query.targetPersona.length !== "" || query.company.length !== "" || query.subCategory.length !== "") || ((selectedCategories.length === 1) || (selectedSubCategories.length === 1) || (selectedAllKeywords.length === 1) || (selectedCompany.length === 1)) || (selectedTargetPersona.length === 1)) {
          setNbPages(nbPages);
        } else {
          setNbPages(0);
        }
        setNbHits(nbHits);
        isMounted = true;
      });
  };
  // when page hits and props change then hit a search
  useEffect(() => {
    if (isMounted) {
      isMounted = false;
      if (isFirstLoad) {
        fetchData();
      }
    }
  }, [props.location]);


  // change pagination and filters function
  const getProductList = async () => {
    setIsFirstLoad(true);
    const query = queryString.parse(props.location.search);

    await searchIndex
      .search(querySearch, {
        facets: ['category', 'subCategory', 'allKeywords', 'company', 'targetPersona'],
        facetFilters: [selectedCategories, selectedSubCategories, selectedAllKeywords, selectedCompany, selectedTargetPersona],
        numericFilters,
        hitsPerPage: 20,
        page
      })
      .then(({
        hits, facets, nbPages, page, nbHits
      }) => {

        let productDetail = hits
        const { category, subCategory } = facets;
        if (category) {
          setCategories(category);
        } else {
          setCategories([]);
        }
        if (subCategory) {
          setSubcategories(subCategory);
        } else {
          setSubcategories([]);
        }
        if (facets.allKeywords) {
          setAllKeywords(facets.allKeywords);
        } else {
          setAllKeywords([]);
        }
        if (facets.company) {
          setCompany(facets.company);
        } else {
          setCompany([]);
        }
        if (facets.targetPersona) {
          setTargetPersona(facets.targetPersona);
        } else {
          setTargetPersona([]);
        }
        let arrayWithoutLogo = [];
        let arrayWithLogo = [];

        productDetail.map((value) => {
          if (value.squareLogo === "") {
            arrayWithoutLogo.push(value)
          } else {
            arrayWithLogo.push(value)
          }
        })
        productDetail = [...arrayWithLogo, ...arrayWithoutLogo]
        setProduct(productDetail);
        if ((nbHits > 20 && querySearch !== "") || ((selectedCategories.length === 1) || (selectedSubCategories.length === 1) || (selectedAllKeywords.length === 1) || (selectedCompany.length === 1) || (selectedTargetPersona.length === 1))) {
          setNbPages(nbPages);
        } else {
          setNbPages(0);
        }
        setNbHits(nbHits);

        setIsFirstLoad(false);
      })
      .catch((err) => {
        console.log(':: err', err);
      });
  };

  // when filter is changed
  useEffect(() => {
    function filterPageUpdate() {
      const queryDetail = {
        search: querySearch,
        category: selectedCategories.join(','),
        company: selectedCompany.join(','),
        allKeywords: selectedAllKeywords.join(','),
        targetPersona: selectedTargetPersona.join(','),
        subCategory: selectedSubCategories.join(','),
        employee: numericFilters.join(','),
        page
      };
      function setParams() {
        const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname
          }?${queryString.stringify(queryDetail)}`;
        window.history.pushState({ path: newurl }, '', newurl);
      }
      // history.push(`/product-list?${queryString.stringify(query)}`);
      if (!isFirstLoad) {
        const url = setParams();
        // props.history.push(`?${queryString.stringify(queryDetail)}`)
        getProductList();
      }
    }

    if (!isFirstLoad) {
      filterPageUpdate();
    }
  }, [selectedCategories, selectedSubCategories, numericFilters, page, querySearch, selectedCompany, selectedAllKeywords, selectedTargetPersona]);

  const changeCategoryFilter = (category, event) => {
    const cat = category;
    const e = event.target.checked;
    if (e) {
      setSelectedCategories([...selectedCategories, cat]);
      setShowProducts({ ...showProducts, category: true })
      setPage(0);
    } else {
      setSelectedCategories(selectedCategories.filter((item) => item !== cat));
      setShowProducts({ ...showProducts, category: false })
      setPage(0);
    }
  };

  const changeCompanyFilter = (companyParam, event = false) => {
    const cat = companyParam;
    const e = event.target.checked;
    if (e) {
      setSelectedCompany([...selectedCompany, cat]);
      setShowProducts({ ...showProducts, company: true })
      setPage(0);
    } else {
      setSelectedCompany(selectedCompany.filter((item) => item !== cat));
      setShowProducts({ ...showProducts, company: false })
      setPage(0);
    }
  };

  const changeAllKeywords = (keywords, event) => {
    const cat = keywords;
    const e = event.target.checked;
    if (e) {
      setSelectedAllKeywords([...selectedAllKeywords, cat]);
      setShowProducts({ ...showProducts, keywords: true })
      setPage(0);
    } else {
      setSelectedAllKeywords(selectedAllKeywords.filter((item) => item !== cat));
      setShowProducts({ ...showProducts, keywords: false })
      setPage(0);
    }
  };

  const changeTargetPersonaFilter = (targetPersona, event) => {
    const cat = targetPersona;
    const e = event.target.checked;
    if (e) {
      setSelectedTargetPersona([...selectedTargetPersona, cat]);

      setPage(0);
    } else {
      setSelectedTargetPersona(selectedTargetPersona.filter((item) => item !== cat));
      setPage(0);
    }
  };

  const changeSubCategoryFilter = (category, event) => {
    event.persist();
    if (event.target.checked) {
      let new_sub_cat = (category.split(':')[1]).toLowerCase().replace(/\s+/g, "-");
      history.push(window.location.pathname + '/' + new_sub_cat);

      setSelectedSubCategories([...selectedSubCategories, category]);
      setShowProducts({ ...showProducts, subCategory: true })
      setPage(0);
    } else {
      let new_sub_cat = (category.split(':')[1]).toLowerCase().replace(/\s+/g, "-");
      let new_pathname = window.location.pathname;
      let updated_pathname = new_pathname.replace("/" + new_sub_cat, "");
      //alert(updated_pathname)
      history.push(updated_pathname);
      setSelectedSubCategories(selectedSubCategories.filter((item) => item !== category));
      setShowProducts({ ...showProducts, subCategory: false })
      setPage(0);
    }
  };

  // go to company page (for search bar)
  const goToCompanyPage = async (val) => {
    isMounted = false;
    setIsFirstLoad(true);
    setSelectedCategories([]);
    setSelectedSubCategories([]);
    setNumericFilters([]);
    if (val && val.product) {
      const query = {
        search: val.objectID,
        //category: [].join(','),
        //subCategory: [].join(','),
        //allKeywords: [].join(','),
        //company: [].join(',')
      };
      await history.push(`/product/${(val.product.toLowerCase()).replace(/\s+/g, "-")}?${queryString.stringify(query)}`, {
        data: {
          params: val
        }
      });
    } else if (val && val.category) {
      const query = {
        search: val.category,
        category: [`category:${val.category}`].join(','),
        //subCategory: [].join(','),
        //allKeywords: [].join(','),
        //company: [].join(','),
        page: 0
      };
      await history.push(`/category/${(val.category.toLowerCase()).replace(/\s+/g, "-")}?${queryString.stringify(query)}`, {
        data: {
          params: val
        }
      });
    } else if (val && val.subCategory) {
      const query = {
        search: val.subCategory,
        //category: [].join(','),
        //allKeywords: [].join(','),
        //company: [].join(','),
        subCategory: [`subCategory:${val.subCategory}`].join(','),
        page: 0
      };
      await history.push(`/category?${queryString.stringify(query)}`, {
        data: {
          params: val
        }
      });
    } else {
      const query = {
        search: val,
        //category: [].join(','),
        //subCategory: [].join(','),
        //allKeywords: [].join(','),
        //company: [].join(','),
        page: 0
      };
      await history.push(`/search/${(val.toLowerCase()).replace(/\s+/g, "-")}?${queryString.stringify(query)}`, {
        data: {
          params: val
        }
      });
    }
  };

  // to refresh the page on state change
  useEffect(() => {
  }, [isMounted, product]);

  // search via algolia for search bar
  const searchFromAlgolia = async (val) => {
    if (isMounted) {
      // setSearchInputValue(val);
      if (val.length < 4) {
        return;
      }
      await searchIndex
        .search(val, {
          attributesToRetrieve: ['product', 'category', 'subCategory', 'targetPersona'],
          facets: ['category', 'subCategory', 'targetPersona'],
          hitsPerPage: 8
        })
        .then(async ({ hits, facets }) => {
          hits = hits.slice(0, 4);
          const products = hits;
          const { category, subCategory } = facets;
          if (category) {
            // eslint-disable-next-line no-unused-expressions
            Object.keys(category)[0]
              ? products.push({
                category: Object.keys(category)[0]
              })
              : '';
            // eslint-disable-next-line no-unused-expressions
            Object.keys(category)[1]
              ? products.push({
                category: Object.keys(category)[1]
              })
              : '';
          }
          if (subCategory) {
            // eslint-disable-next-line no-unused-expressions
            Object.keys(subCategory)[0]
              ? products.push({
                subCategory: Object.keys(subCategory)[0]
              })
              : '';
            // eslint-disable-next-line no-unused-expressions
            Object.keys(subCategory)[1]
              ? products.push({
                subCategory: Object.keys(subCategory)[1]
              })
              : '';
          }
          setOptions(products);
        });
    }
  };

  function removeSearchQuery() {
    setQuerySearch('');
    setNbHits(0);
    setNbPages(0);
  }

  const handleClick = () => {
    setOpen(!open);
  };
  const handleSubClick = () => {
    setIsSubOpen(!isSubOpen);
  };

  const handlePageClick = (data) => {
    setPage(data.selected);
    window.scrollTo(0, 0);
  };
  const classes = useStyles();

  const goToHome = () => history.push('/');
  const userName = localStorage.getItem('user');


  useEffect(() => {
    const node = loadCSS(
      'https://use.fontawesome.com/releases/v5.12.0/css/all.css',
      document.querySelector('#font-awesome-css'),
    );

    return () => {
      node.parentNode.removeChild(node);
    };
  }, []);


  return (
    <div className={classes.root}>
      <AppBar className={classes.headerStyle} position="static">
        <Toolbar>
          <img src={requestlyLogo} style={{ height: "46px", cursor: "pointer" }} onClick={() => { goToHome() }} />
          <div className={classes.rightNav}>
            <nav style={{ position: "relative" }}>
              <div className={`${classes.searchBarWrap} searchBarProduct`}>
                <Autocomplete
                  id="custom-input-demo"
                  value={querySearch}
                  freeSolo
                  classes={{
                    popper: classes.autoCompletePopperProduct
                  }}
                  getOptionLabel={(option) => (typeof option === 'string' ? `${querySearch}` : `${querySearch}`)}
                  filterOptions={(x) => x}
                  options={options}
                  disableClearable
                  onChange={async (event, newValue) => {
                    goToCompanyPage(newValue);

                  }}
                  onInputChange={(e, val) => {
                    searchFromAlgolia(val);
                    setShowProducts({ ...showProducts, val: val })
                    if (val == '') {
                      removeSearchQuery()
                    }
                  }}
                  renderInput={(params) => (
                    <div ref={params.InputProps.ref}>
                      <input
                        {...params.inputProps}
                        className={classes.searchInputStyle}
                        type="search"
                        placeholder="Search company, software name, category, service, CEO..."
                      />
                      <span className="material-icons face">
                        <SearchIcon className={classes.iconSize} />
                      </span>
                    </div>
                  )}
                  renderOption={(option) => {
                    return (
                      <Grid
                        container
                        alignItems="center"
                        onClick={async () => {
                          isMounted = false;
                        }}
                      >
                        <Grid
                          container
                          alignItems="center"
                          onClick={async () => {
                            isMounted = false;
                          }}
                        >
                          <Typography variant="body2" className={classes.autoCompleteTextStyle}>
                            {option && option.product
                              ? `Product: ${option.product}`
                              : `Category: ${option.category ? option.category : option.subCategory
                              }`}
                          </Typography>
                        </Grid>
                      </Grid>
                    );
                  }}
                />
                {userName && userName !== '' ? (
                  <div
                    className={classes.loginButton}
                    onClick={() => {
                      history.push('/app/dashboard');
                    }}
                  >
                    Login
                  </div>
                ) : (
                  <div
                    className={classes.loginButton}
                    onClick={() => {
                      history.push('/auth/login');
                    }}
                  >
                    Login
                  </div>
                )}
              </div>
            </nav>
          </div>
        </Toolbar>
      </AppBar>
      <Grid container className={`${classes.containerPadding}`}>
        <Grid container>
          <Grid item xs={12} sm={4} lg={3} md={4} className={`${classes.gridStyle}`}>
            <List
              className={`${classes.listStyle}`}
              component="nav"
              key="category"
              aria-labelledby="nested-list-subheader"
              subheader={(
                <ListSubheader
                  className={`${classes.listHeader}`}
                  component="div"
                  id="nested-list-subheader"
                >
                  Category
                </ListSubheader>
              )}
            >
              {Object.keys(categories).map((key) => {
                return (
                  <ListItem className={`${classes.listItemCategory}`} key={key}>
                    <ListItemIcon
                      classes={{
                        root: classes.checkBoxStyleList
                      }}
                    >
                      <FormControlLabel
                        classes={{
                          root: classes.categoriesText
                        }}
                        className={`${classes.categoriesName} ${classes.categoriesText}`}
                        label={(
                          <p className={`${classes.categoriesName} ${classes.categoriesText}`}>
                            {' '}
                            {`${key} (${categories[key]})`}
                            {' '}
                          </p>
                        )}
                        control={(
                          <Checkbox
                            disableRipple
                            checked={selectedCategories.includes(`category:${key}`)}
                            onChange={(event) => {
                              changeCategoryFilter(`category:${key}`, event);
                            }}
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                          />
                        )}
                      />
                    </ListItemIcon>
                  </ListItem>
                );
              })}
            </List>

            <List
              className={`${classes.listStyle}  ${classes.employeeFilterList}`}
              component="nav"
              key="subCategory"
              aria-labelledby="nested-list-subheader"
              subheader={(
                <ListSubheader
                  className={`${classes.listHeader}`}
                  component="div"
                  id="nested-list-subheader"
                >
                  Sub Category
                </ListSubheader>
              )}
            >
              {Object.keys(subCategories).map((key, index) => {
                return (
                  <ListItem className={`${classes.listItemCategory}`} key={key}>
                    <ListItemIcon
                      classes={{
                        root: classes.checkBoxStyleList
                      }}
                    >
                      <FormControlLabel
                        classes={{
                          root: classes.categoriesText
                        }}
                        className={`${classes.categoriesName} ${classes.categoriesText}`}
                        label={(
                          <p className={`${classes.categoriesName} ${classes.categoriesText}`}>
                            {' '}
                            {`${key} (${subCategories[key]})`}
                            {' '}
                          </p>
                        )}
                        control={(
                          <Checkbox
                            disableRipple
                            checked={selectedSubCategories.includes(`subCategory:${key}`)}
                            onChange={(event) => {
                              changeSubCategoryFilter(`subCategory:${key}`, event);
                            }}
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            name={key}
                          />
                        )}
                      />
                    </ListItemIcon>
                  </ListItem>
                );
              })}
            </List>
            <List
              className={`${classes.listStyle} ${classes.employeeFilterList}`}
              component="nav"
              key="company"
              aria-labelledby="nested-list-subheader"
              subheader={(
                <ListSubheader
                  className={`${classes.listHeader}`}
                  component="div"
                  id="nested-list-subheader"
                >
                  Company
                </ListSubheader>
              )}
            >
              {Object.keys(company).map((key, index) => {
                return (
                  <ListItem className={`${classes.listItemCategory}`} key={`company${key}`}>
                    <ListItemIcon
                      classes={{
                        root: classes.checkBoxStyleList
                      }}
                    >
                      <FormControlLabel
                        classes={{
                          root: classes.categoriesText
                        }}
                        className={`${classes.categoriesName} ${classes.categoriesText}`}
                        label={(
                          <p className={`${classes.categoriesName} ${classes.categoriesText}`}>
                            {' '}
                            {`${key} (${company[key]})`}
                            {' '}
                          </p>
                        )}
                        control={(
                          <Checkbox
                            disableRipple
                            checked={selectedCompany.includes(`company:${key}`)}
                            onChange={(event) => {
                              changeCompanyFilter(`company:${key}`, event);
                            }}
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                          />
                        )}
                      />
                    </ListItemIcon>
                  </ListItem>
                );
              })}
            </List>
            {/* Target persona */}
            <List
              className={`${classes.listStyle} ${classes.employeeFilterList}`}
              component="nav"
              key="targetPersona"
              aria-labelledby="nested-list-subheader"
              subheader={(
                <ListSubheader
                  className={`${classes.listHeader}`}
                  component="div"
                  id="nested-list-subheader"
                >
                  Target Persona
                </ListSubheader>
              )}
            >
              {Object.keys(targetPersona).map((key, index) => {
                return (
                  <ListItem className={`${classes.listItemCategory}`} key={`targetPersona${key}`}>
                    <ListItemIcon
                      classes={{
                        root: classes.checkBoxStyleList
                      }}
                    >
                      <FormControlLabel
                        classes={{
                          root: classes.categoriesText
                        }}
                        className={`${classes.categoriesName} ${classes.categoriesText}`}
                        label={(
                          <p className={`${classes.categoriesName} ${classes.categoriesText}`}>
                            {' '}
                            {`${key} (${targetPersona[key]})`}
                            {' '}
                          </p>
                        )}
                        control={(
                          <Checkbox
                            disableRipple
                            checked={selectedTargetPersona.includes(`targetPersona:${key}`)}
                            onChange={(event) => {
                              changeTargetPersonaFilter(`targetPersona:${key}`, event);
                            }}
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                          />
                        )}
                      />
                    </ListItemIcon>
                  </ListItem>
                );
              })}
            </List>
            <List
              className={`${classes.listStyle} ${classes.employeeFilterList}`}
              component="nav"
              key="keywords"
              aria-labelledby="nested-list-subheader"
              subheader={(
                <ListSubheader
                  className={`${classes.listHeader}`}
                  component="div"
                  id="nested-list-subheader"
                >
                  Keywords
                </ListSubheader>
              )}
            >
              {Object.keys(allKeywords).map((key, index) => {
                return (
                  <ListItem className={`${classes.listItemCategory}`} key={`allKeywords${key}`}>
                    <ListItemIcon
                      classes={{
                        root: classes.checkBoxStyleList
                      }}
                    >
                      <FormControlLabel
                        classes={{
                          root: classes.categoriesText
                        }}
                        className={`${classes.categoriesName} ${classes.categoriesText}`}
                        label={(
                          <p className={`${classes.categoriesName} ${classes.categoriesText}`}>
                            {' '}
                            {`${key} (${allKeywords[key]})`}
                            {' '}
                          </p>
                        )}
                        control={(
                          <Checkbox
                            disableRipple
                            checked={selectedAllKeywords.includes(`allKeywords:${key}`)}
                            onChange={(event) => {
                              changeAllKeywords(`allKeywords:${key}`, event);
                            }}
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                          />
                        )}
                      />
                    </ListItemIcon>
                  </ListItem>
                );
              })}
            </List>

          </Grid>
          <Grid
            item
            xs={12}
            sm={8}
            lg={9}
            md={8}
            className={`${classes.gridStyle} ${classes.gridStyleList}`}
          >
            {
              showProducts.val.length > 0 ? (
                <Grid>
                  <Typography>
                    Search for &nbsp;
                    <b>
                      {showProducts.val}
                    </b>
                    &nbsp;
                    <CloseIcon className={classes.closeIconStyle} onClick={() => { removeSearchQuery() }} />
                  </Typography>
                </Grid>
              ) : null
            }
            {showProducts.val.length > 0 || selectedCompany.length > 0 || selectedCategories.length > 0
              || selectedSubCategories.length > 0 || selectedAllKeywords.length > 0 || selectedTargetPersona.length > 0 ? <Typography>
              {' '}
              {nbHits}
              {' '}
              results found
            </Typography>
              : ""
            }
            {/* {wordLength.length > 0 && <p>Hello</p>} */}
            {showProducts.val.length > 0 || selectedCompany.length > 0 || selectedCategories.length > 0
              || selectedSubCategories.length > 0 || selectedAllKeywords.length || selectedTargetPersona.length > 0

              ? (<List
                key="productDetailList"
                name="productDetail"
                className={`${classes.productListStyle}`}
              >
                {product.map((detail) => {
                  return (
                    <div>
                      <Divider />
                      <Grid container>

                        <Grid item xs={9} sm={9} lg={9} md={9}>
                          <ListItem
                            button
                            onClick={() => goToCompanyPage(detail)}
                            className={`${classes.listItemDetailStyle}`}
                            key={detail.objectID}
                          >
                            <ListItemAvatar
                              classes={{
                                root: classes.productImage
                              }}
                            >
                              {
                                detail.squareLogo && detail.squareLogo !== ''
                                  && (detail.squareLogo !== "https://requestly-media-public.s3.eu-west-2.amazonaws.com/company_logos/undefined")
                                  ? (
                                    <Avatar classes={{
                                      img: classes.logoFit
                                    }} alt="Logo" src={detail.squareLogo} />
                                  )
                                  : <div style={{ height: "90px", width: "90px", marginRight: "10px" }}></div>
                              }
                            </ListItemAvatar>
                            <ListItemText
                              classes={{
                                secondary: classes.productOverview,
                                primary: classes.productNameStyle
                              }}
                              primary={detail.product}
                              secondary={detail.description}
                            />
                          </ListItem>
                        </Grid>
                        <Grid item xs={3} sm={3} lg={3} md={3}>
                          <ListItem
                            className={`${classes.listItemDetailStyle}`}
                            key={`${detail.objectID}detail`}
                          >
                            <ListItemText
                              classes={{
                                secondary: classes.productOverview
                              }}
                              // primary="Company Details"
                              secondary={(
                                <>
                                  <Box>
                                    <span style={{ marginBottom: "12px" }}>Company Details</span>
                                    {detail.company ? (
                                      <p style={{ margin: 0 }}>
                                        {' '}
                                        <Icon style={{ verticalAlign: 'middle', }} className="far fa-building" />
                                        {detail.company}
                                      </p>
                                    ) : (
                                      ''
                                    )}
                                    {detail.clean_url ? (
                                      <p style={{ margin: 0, marginTop: 10 }}>
                                        {' '}
                                        <Icon style={{ verticalAlign: 'middle' }} className="fas fa-globe" />&nbsp;
                                        <a
                                          href={
                                            detail.clean_url.includes('http')
                                              ? detail.clean_url
                                              : `http://${detail.clean_url}`
                                          }
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          {detail.clean_url}
                                        </a>
                                        {' '}
                                      </p>
                                    ) : (
                                      ''
                                    )}
                                    {detail.hqLocation ? (
                                      <p style={{ margin: 0, marginTop: 10 }}>
                                        {' '}
                                        <Icon style={{ verticalAlign: 'middle' }} className="far fa-compass" />
                                        {detail.hqLocation}
                                      </p>
                                    ) : (
                                      ''
                                    )}
                                  </Box>
                                </>
                              )}
                            />
                          </ListItem>
                        </Grid>
                      </Grid>
                    </div>
                  );
                })}
                <Divider />
              </List>) : "Please enter a search term or use the navigation on the left to refine your search."}

          </Grid>
          {nbPages > 1 && (showProducts.val.length > 0 || selectedCompany.length > 0 || selectedCategories.length > 0
            || selectedSubCategories.length > 0 || selectedAllKeywords.length > 0 || selectedTargetPersona.length > 0) ? (
            <Grid container justify="center">
              <ReactPaginate
                previousLabel="<"
                nextLabel=">"
                breakLabel="..."
                breakClassName="break-me"
                pageCount={nbPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                forcePage={parseInt(page)}
                onPageChange={handlePageClick}
                containerClassName="pagination"
                subContainerClassName="pages pagination"
                activeClassName="active"
              />
            </Grid>
          ) : (
            ''
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default ProductPage;
